var map = {
	"./bonus_cacheback.png": "8aca",
	"./bonus_individual.png": "58ed",
	"./bonus_social.png": "5d2d",
	"./gray_wheel.png": "78b0",
	"./tg_bonus.png": "024f",
	"./wheel.png": "8d1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b13d";